module.exports = __webpack_public_path__ + "img/knight4_banner.2da290e3.jpg";